import { COMPONENTS } from "../../../constants";
let resources_menu_links = [];

// 8 = redi-rock
if (process.env.ASTER_SITE_ID === "8") {
  resources_menu_links = [
    {
      id: "resources-menu",
      page: null,
      __typename: COMPONENTS.SUBNAV_LINK,
      linkText: "Resources",
      subnav_links: [
        {
          link_text: "Resources Home",
          __typename: COMPONENTS.LINK,
          id: "resources-0",
          new_window: false,
          page: {
            slug: "secure/home/"
          }
        },
        {
          link_text: "Production/User Manual",
          __typename: COMPONENTS.LINK,
          id: "resources-1",
          new_window: false,
          page: {
            slug: "secure/production/"
          }
        },
        // {
        //   link_text: "Literature & Promos",
        //   __typename: COMPONENTS.LINK,
        //   id: "resources-2",
        //   new_window: false,
        //   page: {
        //     slug: "secure/literature-and-promotional-items/"
        //   }
        // },
        {
          link_text: "Design/Takeoffs",
          __typename: COMPONENTS.LINK,
          id: "resources-3",
          new_window: false,
          page: {
            slug: "secure/design-takeoffs/"
          }
        },
        {
          link_text: "Sales Resources",
          __typename: COMPONENTS.LINK,
          id: "resources-4",
          new_window: false,
          page: {
            slug: "secure/sales-resources/"
          }
        },
        {
          link_text: "Marketing Resources",
          __typename: COMPONENTS.LINK,
          id: "resources-5",
          new_window: false,
          page: {
            slug: "secure/marketing/"
          }
        },
        {
          link_text: "Training Resources",
          __typename: COMPONENTS.LINK,
          id: "resources-6",
          new_window: false,
          page: {
            slug: "secure/training/"
          }
        },
        {
          link_text: "Photo Database",
          __typename: COMPONENTS.LINK,
          id: "resources-7",
          new_window: true,
          url: "https://asterbrands.mediavalet.com/portals/redi-rock-international"
        },
        {
          link_text: "Business Development Journey",
          __typename: COMPONENTS.LINK,
          id: "resources-8",
          new_window: false,
          page: {
            slug: "secure/bdj/"
          }
        }
      ]
    }
  ];
}

// 4 = rosettahardscapes
if (process.env.ASTER_SITE_ID === "4") {
  resources_menu_links = [
    {
      id: "resources-menu",
      page: null,
      __typename: COMPONENTS.SUBNAV_LINK,
      linkText: "Resources",
      subnav_links: [
        {
          link_text: "Resources Home",
          __typename: COMPONENTS.LINK,
          id: "resources-0",
          new_window: false,
          page: {
            slug: "secure/home/"
          }
        },
        {
          link_text: "Production",
          __typename: COMPONENTS.LINK,
          id: "resources-1",
          new_window: false,
          page: {
            slug: "secure/production/"
          }
        },
        {
          link_text: "Sales",
          __typename: COMPONENTS.LINK,
          id: "resources-2",
          new_window: false,
          page: {
            slug: "secure/sales/"
          }
        },
        {
          link_text: "Marketing",
          __typename: COMPONENTS.LINK,
          id: "resources-3",
          new_window: false,
          page: {
            slug: "secure/marketing/"
          }
        },
        {
          link_text: "Literature and Promo Items",
          __typename: COMPONENTS.LINK,
          id: "resources-4",
          new_window: false,
          page: {
            slug: "secure/literature/"
          }
        },
        {
          link_text: "Webinar Library",
          __typename: COMPONENTS.LINK,
          id: "resources-5",
          new_window: false,
          page: {
            slug: "secure/webinar-library/"
          }
        },
        {
          link_text: "Photo Database",
          __typename: COMPONENTS.LINK,
          id: "resources-6",
          new_window: true,
          url: "https://asterbrands.mediavalet.com/portals/rosetta"
        },
        {
          link_text: "Business Development Journey",
          __typename: COMPONENTS.LINK,
          id: "resources-7",
          new_window: false,
          page: {
            slug: "secure/bdj/"
          }
        }
      ]
    }
  ];
}

// 2 = polebase
if (process.env.ASTER_SITE_ID === "2") {
  resources_menu_links = [
    {
      __typename: COMPONENTS.SUBNAV_LINK,
      id: "resources-menu",
      page: null,
      linkText: "Resources",
      subnav_links: [
        {
          link_text: "Resources Home",
          __typename: COMPONENTS.LINK,
          id: "resources-0",
          new_window: false,
          page: {
            slug: "secure/home/"
          }
        },
        {
          link_text: "Sales",
          __typename: COMPONENTS.LINK,
          id: "resources-1",
          new_window: false,
          page: {
            slug: "secure/sales-resources-for-pole-base-manufacturers"
          }
        },
        {
          link_text: "Marketing",
          __typename: COMPONENTS.LINK,
          id: "resources-2",
          new_window: false,
          page: {
            slug: "secure/marketing-resources-for-pole-base-manufacturers"
          }
        },
        {
          link_text: "Production",
          __typename: COMPONENTS.LINK,
          id: "resources-3",
          new_window: false,
          page: {
            slug: "secure/secure-production/"
          }
        },
        {
          link_text: "Training",
          __typename: COMPONENTS.LINK,
          id: "resources-4",
          new_window: false,
          page: {
            slug: "secure/training/"
          }
        },
        {
          link_text: "Business Development Journey",
          __typename: COMPONENTS.LINK,
          id: "resources-5",
          new_window: false,
          page: {
            slug: "secure/business-development-journey/"
          }
        }
      ]
    }
  ];
}

// 11 = novumwall
if (process.env.ASTER_SITE_ID === "11") {
  resources_menu_links = [
    {
      __typename: COMPONENTS.SUBNAV_LINK,
      id: "resources-menu",
      page: null,
      linkText: "Resources",
      subnav_links: [
        {
          link_text: "Resources Home",
          __typename: COMPONENTS.LINK,
          id: "resources-0",
          new_window: false,
          page: {
            slug: "secure/home/"
          }
        },
        {
          link_text: "Engineering Resources",
          __typename: COMPONENTS.LINK,
          id: "resources-1",
          new_window: false,
          page: {
            slug: "secure/home/#engineering-resources"
          }
        },
        {
          link_text: "Sales & Marketing Resources",
          __typename: COMPONENTS.LINK,
          id: "resources-2",
          new_window: false,
          page: {
            slug: "secure/sales-and-marketing"
          }
        },
        {
          link_text: "Quick Start Guide",
          __typename: COMPONENTS.LINK,
          id: "resources-3",
          new_window: true,
          url: "https://cdn.mediavalet.com/usil/asterbrands/rTBKnxdVMEKijDN7zojkdQ/C9cpr3M970i-5B7XYAQKlA/Original/Novum_Quick_Start_Guide_11_30_2023_a59a599c21.pdf"
        },
        {
          link_text: "Photo Database",
          __typename: COMPONENTS.LINK,
          id: "resources-4",
          new_window: true,
          url: "https://asterbrands.mediavalet.com/portals/novum-wall-projects"
        }
      ]
    }
  ];
}

export default resources_menu_links;
